module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";